import { render, staticRenderFns } from "./DialogHistoricoAlteracoes.vue?vue&type=template&id=3aa3656b"
import script from "./DialogHistoricoAlteracoes.vue?vue&type=script&lang=js"
export * from "./DialogHistoricoAlteracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports